<template>
    <div class='summer_lotto text-center'>
        <h6 class="text-center">{{'lucky_symbols' | lang}}</h6>
        <div class="lucky-symbols w-100 d-flex align-items-center justify-content-center">
            <div v-for="(symbol, itemIndex) in luckySymbols" :key="itemIndex" :class="{'symbol d-flex align-items-center justify-content-center':true, 'lucky' : luckySymbolsArray.includes(symbol)}"> 
                <img class="img-fluid" :src="`/fg/v2/games/summer_lotto/img/symbol-win-${symbol}.png`">
            </div>
        </div>
        <div v-if="ticket.ticket_is_lucky && (luckyYourSymbols.length || luckyBonusSymbols.length)" class="">
            <div v-if="luckyYourSymbols.length">
                <h6 class="text-center pt-3">{{'your_symbols' | lang}}</h6>
                <div class="your-symbols w-100 d-flex align-items-center justify-content-center justify-content-lg-start flex-wrap">
                    <div v-for="(item, itemIndex) in luckyYourSymbols" :key="itemIndex" class="symbol"> 
                        <div v-if="item.symbol" class="w-100">
                            <img v-if="item.symbol === 'multiplier'" class="img-fluid" :src="`/fg/v2/games/summer_lotto/img/SpecialSymbol.png`">
                            <img v-else="item.symbol === 'multiplier'" class="img-fluid" :src="`/fg/v2/games/summer_lotto/img/symbol-win-${item.symbol}.png`">
                            <span class="amount">
                                {{ item.amount | currency }}
                            </span>
                        </div>
                        <div v-else>
                            <img class="img-fluid" :src="`/fg/v2/games/summer_lotto/img/SpecialSymbol.png`">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class = 'no-winnings d-flex align-items-center justify-content-center'>
            <h6>{{'noWinning' | lang}}</h6>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['ticket', 'gameName'],
        data() {
            return {
                luckySymbolsArray:[]
            }
        },
        computed: {
            luckySymbols() {
                let luckies = [];
                this.luckySymbolsArray = [];

                for (const [key, symbol] of Object.entries(this.ticket.scenario.lucky_symbols)) {
                    luckies.push(symbol);
                }

                return luckies;
            },
            luckyYourSymbols() {
                let luckies = [];
                this.luckySymbolsArray = [];

                for (const [key, symbol] of Object.entries(this.ticket.scenario.your_symbols)) {
                    if (symbol === 'bonus_symbol') {
                        this.luckySymbolsArray.push(symbol);
                        luckies.push(symbol);
                    } else if (symbol.multiplier) {
                        this.luckySymbolsArray.push(`multiplier_${symbol.multiplier}`);
                        luckies.push(`multiplier_${symbol.multiplier}`);
                    } else if (symbol.win || symbol.win_after) {
                        luckies.push(symbol);
                        this.luckySymbolsArray.push(symbol.symbol);
                    }
                }

                return luckies;
            },
            luckyBonusSymbols() {
                let luckies = [];

                if (this.ticket.scenario.bonus && this.ticket.scenario.bonus.luckies) {
                    for (const [key, amount] of Object.entries(this.ticket.scenario.bonus.luckies)) {
                        if (amount) {
                            luckies.push(amount);
                        }
                    }
                }

                return luckies;
            }
        }
    }
</script>

<style>
    @font-face {
        font-family: "DKGardenGnome";
        src: local("DKGardenGnome"), url(/fg/v2/games/summer_lotto/fonts/DKGardenGnome.otf) format("truetype");
    }

    .summer_lotto .symbol {
        width: 33.33%;
        padding: 5px;
        max-width: 80px;
        position: relative;
    }

    .summer_lotto .lucky-symbols .symbol {
        opacity: 0.5;
    }

    .summer_lotto .lucky-symbols .symbol.lucky {
        opacity: 1;
    }

    .summer_lotto .your-symbols .amount {
        position: absolute;
        bottom: 5px;
        text-align: center;
        font-family: DKGardenGnome;
        width: 100%;
        font-size: 20px;
        margin-left: auto;
        margin-right: auto;
        color: #ffffff;
        white-space: nowrap;
        transform: translateX(-50%);
        left: 50%;
        text-shadow: 0px 0px 3px #00B0BD;
    }

    .summer_lotto .no-winnings {
        height: 100px;
        width: 100%;
        border: 1px white dotted;
        border-radius: 10px;
        margin-top: 15px;
    }

</style>
